import { DynamicContextProvider } from "@dynamic-labs/sdk-react-core";
import { EthereumWalletConnectors } from "@dynamic-labs/ethereum";
import Main from "./Main";


const App = () => (
  <DynamicContextProvider
    theme="auto"
    settings={{
      environmentId: "ce1ef411-1fca-4659-87ae-c94804bd9dc8",
      walletConnectors: [EthereumWalletConnectors],
    }}
  >
    <Main />
  </DynamicContextProvider>
);

export default App;